import { render } from "./CardBodyContainer.vue?vue&type=template&id=41085f8e"
import script from "./CardBodyContainer.vue?vue&type=script&lang=js"
export * from "./CardBodyContainer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__